module.exports = __webpack_public_path__ + "static/syedna-muffaddal-f09a7e37152338f58aa811c7c3e1a678.jpg";